import React from 'react';
import { Button } from 'hui';
import { Assessment } from '../../interfaces';
import { History } from 'history';

// will have logic later when needed, currently just treat tradeCategory as category
const mapTradeCategoryToCategory = (tradeCategory: string) => tradeCategory.toLowerCase();

// have to use this way since use hooks inside component will cause invalid hook usage.
// it's a react-table bug https://stackblitz.com/edit/react-qzdore
export const PostButtonWithHistory = (history: History) => (text: any, record: Assessment) => {
  const { tradeCategory } = record;
  const category = mapTradeCategoryToCategory(tradeCategory);
  const redirectToCreateJobPage = () => {
    history.push(`/doe/create_job/${category}`);
  };

  return (
    <Button color="primary" ghost onClick={redirectToCreateJobPage}>
      POST
    </Button>
  );
};
